import type { AdminCrewReportUploadModalActionsProps } from "../../models/admin-crew-report.models";
import { CheckIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

const SUBMIT_MESSAGE_ID = "admin-crew-report-upload-submit-message";

const AdminCrewReportUploadModalActions = ({
  disabledReason,
  isSaving,
  message,
  messageDetails,
  messageTone,
  onCancel,
  onSubmit,
}: AdminCrewReportUploadModalActionsProps) => {
  const statusMessageClassName = twMerge(
    "min-w-0 flex-1 text-xs font-medium",
    messageTone === "error" ? "text-[#BF0002]" : "text-[#637381] dark:text-gray-400",
  );
  const statusMessageContent = (
    <>
      <p>{message || disabledReason || "Submit stores this verified grid as the latest crew report for the IMO."}</p>
      {messageDetails.length > 0 && (
        <ul className="mt-1 max-h-24 list-disc overflow-y-auto pl-4">
          {messageDetails.map((detail, index) => (
            <li key={`${detail}-${index}`}>{detail}</li>
          ))}
        </ul>
      )}
    </>
  );

  return (
    <footer className="flex flex-none flex-col gap-3 border-t border-gray-200 px-5 py-3 dark:border-gray-700 md:flex-row md:items-center md:justify-between">
      {messageTone === "error" ? (
        <div id={SUBMIT_MESSAGE_ID} className={statusMessageClassName} role="alert">
          {statusMessageContent}
        </div>
      ) : (
        <div id={SUBMIT_MESSAGE_ID} className={statusMessageClassName} role="status">
          {statusMessageContent}
        </div>
      )}
      <div className="flex justify-end gap-2">
        <button
          type="button"
          data-test="admin-crew-report-upload-modal-cancel"
          onClick={onCancel}
          disabled={isSaving}
          className="h-10 border border-gray-300 px-4 text-sm font-semibold text-[#4A5655] transition-colors hover:bg-[#F8FBFA] disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          type="button"
          data-test="admin-crew-report-upload-modal-submit"
          disabled={Boolean(disabledReason) || isSaving}
          aria-describedby={SUBMIT_MESSAGE_ID}
          className={twMerge(
            "inline-flex h-10 items-center gap-2 bg-green px-4 text-sm font-semibold text-white",
            (Boolean(disabledReason) || isSaving) && "cursor-not-allowed opacity-50",
          )}
          onClick={onSubmit}
        >
          <CheckIcon className="h-5 w-5" />
          {isSaving ? "Saving" : "Submit"}
        </button>
      </div>
    </footer>
  );
};

export default AdminCrewReportUploadModalActions;
